module.exports = {
  'clientVersion': 'hjjcn',
  'stage': 'prod',
  'appName': '围棋星球',
  'locale': 'zh-CN',
  'regionCode': 'CN',
  'manifest': {
    'name': '欢迎来到围棋星球',
    'homePageUrl': 'https://www.weiqistar.com/',
    'appUrl': 'https://app.weiqistar.com/',
    'igqe': 'https://tw.igqe.org/#/',
  },
  'academyId': {
    'dev': '1908eadc-e8de-4c40-a24a-ce14e530acf2',
    'beta': '909ffbe8-8531-4383-9fd7-e86c38a4787c',
    'stg': 'ef8f1baa-fe3b-4c71-9bfc-680bf95234f5',
    'prod': 'ef8f1baa-fe3b-4c71-9bfc-680bf95234f5',
  },
  'aiGame': {
    'victoryCondition': { 'black': { '9': 44, '13': 88, '19': 185 }, 'white': { '9': 38, '13': 82, '19': 177 } },
  },
  'appConfigs': {
    'ios': { 'store': 'itms-apps://itunes.apple.com/tw/app/黑嘉嘉圍棋/id1581621835', 'build': 1 },
    'android': { 'store': 'market://details?id=com.heijiajia.tw', 'build': 1 },
  },
  'awsConfigs': {
    'privateBucket': 'goer-private',
    'cdnBucket': 'hei-jia-jia-cn.weiqi.study-cdn',
    'region': 'cn-north-1',
    'identityPoolId': 'cn-north-1:a0442292-5116-4989-94b9-26b7afa32f98',
  },
  'loginMethods': [ 'phone', 'email', 'activity', 'google', 'apple' ],
  'avatarsNumber': 15,
  'liveCourseReplayDays': 365,
  'shareJwt': false,
  'videoCdn': 'https://v-cdn.weiqistar.com/',
  'publicVideoCdn': 'https://public-video-cdn.weiqistar.com/',
  'appUrl': 'https://app.weiqistar.com/',
  'ICP': '粤ICP备2025374594号-1',
  'abVersion': 'a',
};